import { render, staticRenderFns } from "./ButtonLinkDownload.vue?vue&type=template&id=15a3ec2e&"
import script from "./ButtonLinkDownload.vue?vue&type=script&lang=js&"
export * from "./ButtonLinkDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports